import Grid from '@material-ui/core/Grid';
import {
    SettingsLayout,
    UserSettingsAuthProviders,
    UserSettingsFeatureFlags,
    UserSettingsIdentityCard,
    UserSettingsProfileCard,
    userSettingsPlugin,
} from '@backstage/plugin-user-settings';
import {createRoutableExtension} from '@backstage/core-plugin-api';
import {UserNotificationSettingsCard} from '@backstage/plugin-notifications';
import {ThemeSelectorCard} from './ThemeSelectorCard';

function GeneralSettingsTab() {
    return (
        <Grid container direction="row" spacing={3}>
            <Grid item xs={12} md={6}>
                <UserSettingsProfileCard/>
            </Grid>
            <Grid item xs={12} md={6}>
                <UserSettingsIdentityCard/>
            </Grid>
            <Grid item xs={12}>
                <ThemeSelectorCard/>
            </Grid>
        </Grid>
    );
}

/** Custom settings page that replaces the built-in theme toggle with the grid theme selector. */
function CustomSettingsPageContent() {
    return (
        <SettingsLayout>
            <SettingsLayout.Route path="general" title="General">
                <GeneralSettingsTab/>
            </SettingsLayout.Route>
            <SettingsLayout.Route path="auth-providers" title="Auth Providers">
                <UserSettingsAuthProviders/>
            </SettingsLayout.Route>
            <SettingsLayout.Route path="feature-flags" title="Feature Flags">
                <UserSettingsFeatureFlags/>
            </SettingsLayout.Route>
            <SettingsLayout.Route path="notifications" title="Notifications">
                <UserNotificationSettingsCard
                    originNames={{'plugin:scaffolder': 'Scaffolder'}}
                />
            </SettingsLayout.Route>
        </SettingsLayout>
    );
}

/**
 * Routable extension wrapper so the `user-settings` route ref gets a path.
 * Without this the sidebar Settings item throws
 * "No path for routeRef{type=absolute,id=user-settings}".
 */
export const CustomSettingsPage = userSettingsPlugin.provide(
    createRoutableExtension({
        name: 'CustomSettingsPage',
        component: () => Promise.resolve(CustomSettingsPageContent),
        mountPoint: userSettingsPlugin.routes.settingsPage,
    }),
);
